import { render, staticRenderFns } from "./HRMDataInfo.vue?vue&type=template&id=9f14ea9e&scoped=true&"
import script from "./HRMDataInfo.vue?vue&type=script&lang=ts&"
export * from "./HRMDataInfo.vue?vue&type=script&lang=ts&"
import style0 from "./HRMDataInfo.vue?vue&type=style&index=0&id=9f14ea9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f14ea9e",
  null
  
)

export default component.exports
import {QTable,QTr,QTh} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QTr,QTh})
